export default __webpack_public_path__ + "static/media/jiagou.7302ed96.png";